import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function InfoPill({ className, icon = null, text }) {
  return (
    <div className={classNames('info-pill', className)}>
      {icon}
      <span>{text}</span>
    </div>
  );
}

InfoPill.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node,
  text: PropTypes.node.isRequired,
};
